import type { FC } from "react";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import SelfSchedulingDemo from "../SelfSchedulingDemo/SelfSchedulingDemo";
import { SelfScheduling } from "./SelfScheduling";

export const SelfSchedulingWrapper: FC = () => {
	const { isSnfDemo, isHospitalDemo } = useHospitalData();
	if (isHospitalDemo || isSnfDemo) return <SelfSchedulingDemo />;

	return <SelfScheduling />;
};
